/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import React from 'react'
import TysiaSelect from 'DesignSystem/TysiaSelect/index'
import TysiaSelectContent from 'DesignSystem/TysiaSelect/TysiaSelectContent/index'
import TysiaSelectField from 'DesignSystem/TysiaSelect/TysiaSelectField/react'
import TysiaSelectLabel from 'DesignSystem/TysiaSelect/TysiaSelectLabel/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/DataVaxiomSysOrganizationsParentCompanyLocationSelect/Location/Content",
  allowEmptyChoice,
  onChange
  
}) {
let locationsValueData = fromData.useDataFormat({ viewPath,
context: 'locations',
format: fromFormat.listWithUuid,
})
let selectedLocationIdValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'location_id',
})
let selectedLocationIdChangeData = fromData.useDataChange({ viewPath,
context: 'selected',
path: 'location_id',
})
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<TysiaSelect
  viewPath={`${viewPath}/TysiaSelect`}
 allowEmptyChoice={allowEmptyChoice}
 data="locations"
 format="/Data/format.js listWithUuid"
 from={locationsValueData}
 data="selected.location_id"
 onChange={selectedLocationIdChangeData}
 value={selectedLocationIdValueData}
 maxWidth={240}
 marginRight={dtSpaceXs}
 flexGrow={0}
>
{childProps => (
<React.Fragment>
<TysiaSelectLabel
{...childProps}
  viewPath={`${viewPath}/TysiaSelectLabel`}
 text="Location"
/>
<TysiaSelectContent
{...childProps}
  viewPath={`${viewPath}/TysiaSelectContent`}
>
{childProps => (
<TysiaSelectField
{...childProps}
  viewPath={`${viewPath}/TysiaSelectField`}
/>
)}
</TysiaSelectContent>
</React.Fragment>
)}
</TysiaSelect>
{children}
</React.Fragment>)
}